import { requestWithAuth } from '@/utilities/graphQLClient';
import { gql } from 'graphql-request';
import type { CurrencyISO } from '@/constants/currencies';
import type { AggregatePortfolio } from '@/hooks/portfolio/useAggregatePortfolio';

import { AGGREGATE_PORTFOLIO_FRAGMENT } from '@/hooks/portfolio/useAggregatePortfolio';

type Response = {
  errors?: Error[];
  changeAggregatePortfolioCurrency?: AggregatePortfolio;
};

export const mutationFn = async (payload: { currency: CurrencyISO }) => {
  const response = await requestWithAuth<Response>(
    gql`
      mutation changeAggregatePortfolioCurrency($currency: String!) {
        changeAggregatePortfolioCurrency(currency: $currency) {
          ...aggregatePortfolioFields
        }
      }
      ${AGGREGATE_PORTFOLIO_FRAGMENT}
    `,
    {
      currency: payload.currency,
    }
  );

  if ('changeAggregatePortfolioCurrency' in response) {
    return response.changeAggregatePortfolioCurrency;
  }
};
